import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import brandedUrlShortener from 'shared/assets/images/brandedUrlShortener/brandedUrlShortener.png'
import { getCDNAssetURL } from 'shared/lib'
import { type AddOnsStore } from 'pages/settings/pages/addOns/store/addOnsStore'
import styles from './styles.module.scss'

type IModalContentProps = {
  store: AddOnsStore
}

export const ModalContent = observer(({ store }: IModalContentProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <Typography ariaLabel='brandedUrlShortener' variant='heading-lg'>
          Branded URL Shortener
        </Typography>
        <Typography ariaLabel='brandedUrlShortenerPrice' variant='body-rg-regular'>
          {store.brandedUrlShortenerPriceText}
        </Typography>
      </div>

      <Typography
        ariaLabel='brandedUrlShortenerDescription'
        variant='body-rg-regular'
        color='var(--content-primary-tertiary)'
        marginTop='10px'
        marginBottom='34px'
      >
        Shorten links with your own custom domain to boost brand trust and <br />
        click-through.
      </Typography>

      <img
        src={getCDNAssetURL(brandedUrlShortener)}
        alt='brandedUrlShortener'
        className={styles.image}
      />
    </div>
  )
})
